import type { FaireProductEntity } from "../../entity_types/product";

export const atc_goes_well_5: FaireProductEntity = {
  token: "atc_goes_well_5",
  type: "product",
  name: "Wave Pitcher - Green",
  brandName: "Sophie Lou Jacobsen",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/73fb1a0621706b66c675ddfd50fe55739bafca6502e8890bf5c3702c055b254d.jpeg",
  priceDollars: 42,
  msrpDollars: 85,
  description: "Recommended accessory for ATC flow.",
  tags: ["goes-well-with", "atc"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
